export const dymitrLeszko = {
    'mydrId': 'dymitrleszko',
    'firstName': 'Dymitr',
    'lastName': 'Leszko',
    'profession': 'Psycholog, Psychoterapeuta',
    'avatar': 'dymitr-leszko.webp',
    'slug': 'psycholog-psychoterapeuta-dymitr-leszko',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'adult'],
        ['psychology', 'consultation']
    ]
}